module.exports = __webpack_public_path__ + "images/05a886d0befffba36d70730ca2bba09d.svg";